import Vue from 'vue'

Vue.filter('buyerNumber' ,number => {
  if(number > 10000) {
    return (number / 10000).toFixed(1) + 'W'
  }
  return number
})



Vue.filter('timeCalMonth', time => {
  const t = new Date(time * 1000)
  let month = t.getMonth() + 1
  if(month < 10) {
    month = `0${month}`
  }
  let day = t.getDate()
  if(day < 10) {
    day = `0${day}`
  }
  return `${month}-${day}`
})

Vue.filter('timeCalYear', time => {
  const t = new Date(time * 1000)
  const year = t.getFullYear()
  const now = (new Date()).getFullYear()
  if(year != now) {
    return `${year}`
  }
  return ``
})

Vue.filter('buyerDate', time => {
  const t = new Date(time * 1000)
  const year = t.getFullYear()
  let month = t.getMonth() + 1
  if(month < 10) {
    month = `0${month}`
  }
  let day = t.getDate()
  if(day < 10) {
    day = `0${day}`
  }
  const now = (new Date()).getFullYear()
  if(year != now) {
    return `${year}-${month}-${day}`
  }
  return `${month}-${day}`
})